export default class StickyMenu {

    constructor() {

        jQuery('body').on('click', '.notification__exit', function (e){
            jQuery('body').addClass('closed-notification');
        })


        if (jQuery('div').hasClass('press-release-sidebar-menu')) {

            jQuery('.menu-item:not(.menu-item-has-children) a').on('click', function (e){
                jQuery('.mobile-plus-toggle-menu').click();
            })

            const menuItems = jQuery('.press-release-sidebar-menu__item').each(function (i, e) {
                const hash = jQuery(this).find('a').attr("href").split('#')[1];
                jQuery(this).attr('data-hash', '#' + hash);
            });

            var lastId;
            const scrollItems = menuItems.map(function () {
                const item = jQuery(jQuery(this).attr("data-hash"));
                if (item.length) { return item[0]; }
            });

            jQuery(window).scroll(function () {
                const fromTop = jQuery(this).scrollTop() + jQuery('.elementor-location-header').outerHeight() + 50;
                let cur = scrollItems.filter(function () {
                    return jQuery(this).offset().top < fromTop;
                }).last();
                const id = cur.length ? cur[0].id : "";
                if (lastId !== id) {
                    lastId = id;
                    menuItems.removeClass("active-link")
                        .filter("[data-hash='#" + id + "']").addClass("active-link");
                }
            });
        }


        if(jQuery('header').hasClass('header-v2')){
            jQuery(window).scroll(function () {
                const fromTop = jQuery(this).scrollTop();
                if(fromTop>200){
                    !jQuery('.header-v2').hasClass('elementor-sticky--effects') ? jQuery('.header-v2').addClass('elementor-sticky--effects') : '';
                }else{
                    jQuery('.header-v2').hasClass('elementor-sticky--effects') ? jQuery('.header-v2').removeClass('elementor-sticky--effects') : '';
                }
            });
        }
    }
}


